import { get } from "lodash"
import type { Account, NullableAccountType } from "../../index"
import type { AppState } from "../reducer"

export const getAccount = (state: AppState): Account | null => {
  return state.account.account
}
export const getAccountType = (state: AppState): NullableAccountType => {
  return get(state, "account.account.type")
}
